import styled from "styled-components";

import { bp, media } from "@styles/Utilities.styled";


export const StyledDiv = styled.div`
  display: none;

  ${media(bp.large1)} {
    display: block;
  }
`;
